import { createRouteRef } from '@mainstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-practice-shaper',
});
